import { useCourseStatus } from "api/course-status";
import { MdOpenInNew } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import React from "react";
import { InputLabel } from "components/atoms";
import { routes } from "consts";

interface CourseRatingsProps {
  courseId: number;
  hideStatusLabel?: boolean;
}
export const CourseStatus = ({ courseId, hideStatusLabel }: CourseRatingsProps) => {
  const { isLoading, status } = useCourseStatus(courseId);
  return (
    <div className="space-y-2">
      {!hideStatusLabel && <InputLabel name="status" label="Status" />}
      {isLoading ? (
        <Skeleton count={4} height={25} containerClassName="flex flex-col" className="rounded-lg" />
      ) : (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <SingleStatus
            label="Dla kursanta"
            isReady={status?.publicDataReady}
            href={routes.COURSES_EDIT_NESTED.PREVIEW(courseId)}
          />
          <SingleStatus
            label="Zjazdy"
            isReady={status?.sessionsReady}
            href={routes.COURSES_EDIT_NESTED.SESSION(courseId)}
          />
          <SingleStatus
            label="Egzaminy"
            isReady={status?.examsReady}
            href={routes.COURSES_EDIT_NESTED.EXAMS(courseId)}
          />
          <SingleStatus
            label="Transze płatności"
            isReady={status?.tranchesReady}
            href={routes.COURSES_EDIT_NESTED.PAYMENTS(courseId)}
          />
          <SingleStatus
            label="Dokumenty"
            isReady={status?.documentsReady}
            href={routes.COURSE_PAGE.DOCUMENTS(courseId)}
          />
          <SingleStatus
            label="Formularz zgłoszeniowy"
            isReady={status?.applicationFormReady}
            href={routes.COURSES_EDIT_NESTED.FORM(courseId)}
          />
          <SingleStatus
            label="Harmonogram"
            isReady={status?.scheduleReady}
            href={routes.COURSES_EDIT_NESTED.SCHEDULE(courseId)}
          />
          <SingleStatus
            label="Harmonogram - miejsca"
            isReady={status?.arePlacesPublic}
            href={routes.COURSES_EDIT_NESTED.SCHEDULE(courseId)}
          />
          <SingleStatus
            label="Strefa studenta"
            isReady={status?.resourcesReady}
            href={routes.COURSES_MANAGE_NESTED.RESOURCES(courseId)}
          />
        </div>
      )}
    </div>
  );
};

interface SingleStatusProps {
  label: string;
  isReady?: boolean;
  href: string;
}

const SingleStatus = ({ label, isReady, href }: SingleStatusProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`group relative block cursor-pointer rounded-lg border transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md ${
        isReady
          ? "border-emerald-300 bg-gradient-to-br from-emerald-500 to-emerald-600 hover:border-emerald-400"
          : "border-amber-300 bg-gradient-to-br from-amber-500 to-orange-500 hover:border-amber-400"
      }`}
    >
      <div className="flex flex-col space-y-2 p-3">
        {/* Header with icon */}
        <div className="flex items-center justify-between">
          <div className="text-xs font-medium leading-tight text-white">{label}</div>
          <MdOpenInNew className="h-3 w-3 text-white/70 transition-colors duration-200 group-hover:text-white" />
        </div>

        {/* Status text */}
        <div className="text-xs font-semibold uppercase tracking-wide text-white/90">
          {isReady ? "Gotowe" : "Niegotowe"}
        </div>
      </div>
    </a>
  );
};
